module.exports = __webpack_public_path__ + "img/icon_wanchenglv.e9c30a35.png";